<template>
  <!-- 购物车类型卡片 -->
  <div class="cardBox">
    <div class="titleBox" v-if="data.title">
      <van-row class="titleRow">
        <!-- 0315，潘婧又不要分类全选了，先注释 -->
        <!-- <van-checkbox
          v-model="data.checkAll"
          shape="square"
          checked-color="#3088c5"
          @click="clickTitle(data.checkAll)"
          :disabled="isDesabled"
        > -->
        <span class="title"
          ><img v-if="data.type === 'planData'" src="../../assets/images/handShake.png" class="iconImg" />
          <img v-if="data.type === 'tyreData'" src="../../assets/images/iconTyre.png" class="iconImg" />
          <img v-if="data.type === 'tyrePlanData'" src="../../assets/images/tyreplanIcon.png" class="iconImg" />
          <img v-if="data.type === 'shopData'" src="../../assets/images/vipMark.png" class="iconImg" />{{ data.title }}</span
        >
        <!-- </van-checkbox> -->
      </van-row>
    </div>
    <carCard ref="carCardRef" class="carCardBox" :data="data.list" :isCheckAll="data.checkAll" :type="data.type" :isManage="isManage" />
    <p class="explain">
      <van-icon name="question-o" />
      <span>最终实际成交价格以所选梅赛德斯-奔驰授权经销商零售价格为准。</span>
      <span v-if="['planData', 'tyrePlanData'].includes(data.type)">支付成功后，实际购买结果以经销商接单为准。</span>
    </p>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed } from 'vue'
import carCard from '@/components/shoppingCart/CarCard'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isManage: {
      type: Boolean,
      default: false
    }
  },
  components: {
    carCard
  },
  emits: ['clickTitle'],
  setup(props) {
    const carCardRef = ref()
    let { data, isManage } = toRefs(props)
    const state = reactive({
      data,
      isManage
    })
    const clickTitle = v => {
      carCardRef.value.checkAll(v)
    }
    const isDesabled = computed(() => {
      return state.data.type === 'tyreData' && state.data.list.some(item => !item.hasProduct)
    })
    return {
      ...toRefs(state),
      clickTitle,
      carCardRef,
      isDesabled
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  margin-bottom: 8px;
  background-color: #fff;
}
.titleBox {
  padding-left: 20px;
  background-color: #fff;
}
.titleRow {
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  color: #333;
  vertical-align: middle;
  .title {
    font-weight: 600;
  }
}
.iconImg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}
.explain {
  padding: 12px 30px 20px;
  color: #999;
  .van-icon {
    margin-right: 8px;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
  }
}
</style>
